import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rgba } from 'polished';

const CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

CarouselDots.Dot = styled.div`
  width: 15px;
  height: 15px;
  margin: 0 3px;
  border-radius: 100%;
  border: ${({ theme, color }) =>
    `2px solid ${rgba(theme.colors[color], 0.6)}`};
  background-color: transparent;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
    background-color: ${({ theme, color }) => rgba(theme.colors[color], 0.2)};
  }

  ${({ theme, color, active }) =>
    active && `background-color: ${rgba(theme.colors[color], 0.6)}`};
`;

CarouselDots.defaultProps = {
  color: 'white',
};

CarouselDots.propTypes = {
  color: PropTypes.string,
};

export default CarouselDots;
